/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Instructions_Not_ConfiguredInputs */



/**
* | output |
* | --- |
* | "Not configured" |
*
* @param {Project_Instructions_Not_ConfiguredInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_instructions_not_configured = /** @type {((inputs?: Project_Instructions_Not_ConfiguredInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Instructions_Not_ConfiguredInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nicht konfiguriert")
	return /** @type {LocalizedString} */ ("Not configured")
});